import React, { useContext } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";


export  const RegisteredPapers = () => {
    const { data, papers: data_papers } = useContext(RegistrationContext);
    const papers = data.papers.map((paper: any) => {
      const data_paper = data_papers.find(
        (x: any) => x.paper_id === paper.paper_id
      );

      return {
        paper_id: paper.paper_id,
        title: data_paper ? data_paper.title : "Unknown Title",
        author_names: data_paper ? data_paper.author_names : "Unknown Author",
      };
    });
    return (
      <div
        className=" rounded-lg border bg-white p-6 shadow-sm "
        id="cancellation"
      >
        <h2 className="mb-4 text-xl font-bold">Registered Papers</h2>
        {papers.map((paper: any) => {
          return (
            <div
              key={paper.paper_id}
              className="p-2 rounded-md border border-blue-600 bg-blue-50 text-sm mb-6"
            >
              <div className="flex justify-between items-center">
                <div className="flex-1 mr-2">
                  <h3 className="font-medium">
                    <b>{paper.paper_id}</b>: {paper.title}
                  </h3>
                  <div className="mt-1">
                    <span className="text-xs text-blue-700">
                      {paper.author_names}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };
